// TODO: Delete and replace or add type checking
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export interface Bundle {
    title: string;
    price: Price;
    discount: Price;
    products: Products;
}

interface Price {
    amountInCents: number;
    currency: string;
}

interface Feature {
    id: string;
    value?: string | number;
}

export interface Product {
    title: string;
    logoUrl: string;
    features: Feature[];
}

interface Products {
    [id: string]: Product;
}

const bundles = () => {
    return {
        'logo-web-squarespace-essential': {
            title: 'Logo & Squarespace Essentials',
            price: {
                amountInCents: 139900,
                currency: 'USD',
            },
            discount: {
                amountInCents: 30000,
                currency: 'USD',
            },
            products: {
                'logo-design': {
                    title: __('Logo design'),
                    features: [
                        {
                            id: 'multiple-concepts',
                        },
                        {
                            id: 'finished-custom-logo-design',
                        },
                        {
                            id: 'money-back-guarantee',
                        },
                    ],
                },
                squarespace: {
                    title: 'Squarespace',
                    logoUrl: 'categoryPage/bundleFeatureComparison/squarespace-black.svg',
                    features: [
                        {
                            id: 'content-uploads',
                        },
                        {
                            id: 'design-revisions',
                            value: 2,
                        },
                        {
                            id: 'website-pages',
                            value: __('Up to 5'),
                        },
                        {
                            id: 'third-party-plugin',
                            value: 1,
                        },
                        {
                            id: 'ready-to-launch',
                            value: 14,
                        },
                    ],
                },
            },
        },
        'logo-web-squarespace-ecommerce': {
            title: __('Logo & Squarespace Ecommerce'),
            price: {
                amountInCents: 179900,
                currency: 'USD',
            },
            discount: {
                amountInCents: 30000,
                currency: 'USD',
            },
            products: {
                'logo-design': {
                    title: __('Logo design'),
                    features: [
                        {
                            id: 'multiple-concepts',
                        },
                        {
                            id: 'finished-custom-logo-design',
                        },
                        {
                            id: 'money-back-guarantee',
                        },
                    ],
                },
                squarespace: {
                    title: 'Squarespace',
                    features: [
                        {
                            id: 'content-uploads',
                        },
                        {
                            id: 'ecommmerce-capabilities',
                        },
                        {
                            id: 'website-pages',
                            value: __('Up to 10'),
                        },
                        {
                            id: 'design-revisions',
                            value: 3,
                        },
                        {
                            id: 'third-party-plugin',
                            value: 1,
                        },
                        {
                            id: 'ready-to-launch',
                            value: 21,
                        },
                    ],
                },
            },
        },
    };
};

export const getBundles = (bundleIds: string[]): Bundle[] => {
    return bundleIds.map((id) => bundles()[id]);
};
